var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createApparatus } from "apparatus/library";
import { requestDiameter } from "apparatus/library/bung";
import { Arrays } from "ext/array";
import { t_add } from "i18n_utils";
import { Path, Rectangle, Shape } from "paper";
import { staticImplements } from "types";
import { addEdgeLips, breakPath, mirrorX, setDefaultStyle } from "../draw";
import { P, Pp, Segments } from "./common";
let TestTube = class TestTube {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 8, maxX: 30,
                minY: 75, maxY: 200,
                fromAppearance: a => P(a.width, a.height),
                toAppearance: (f, p) => f({ width: p.x, height: p.y }),
                scale: 2.0,
            }
        ];
    }
    render(appearance) {
        let width = appearance.width;
        let height = appearance.height;
        let graphic = new Path();
        graphic.addSegments(Segments([[0, 0]], [[0, height - width / 2], undefined, [0, width / 1.55]]));
        mirrorX(graphic, width / 2);
        addEdgeLips(graphic, { lipSize: 2.0 });
        let liquidMask = graphic.clone();
        setDefaultStyle(graphic);
        var hitShape = Shape.Rectangle(new Rectangle(0, 0, width, height));
        return {
            graphic: graphic,
            hitShape: hitShape,
            liquidMask: liquidMask,
            liquidMaskOpening: { start: liquidMask.segments[0].point, end: Arrays.last(liquidMask.segments).point },
            snapping: { type: "neck", top: P(width / 2, 0), diameter: width, facing: 0 }
        };
    }
};
TestTube.properties = {
    label: "Test tube",
    canContainLiquids: true,
    meniscus: true,
    pourable: true,
    defaultAppearance: {
        // Size of a regular test tube = 16, according to
        // https://www.homesciencetools.com/product/glass-test-tubes/
        // However we use 24 so it's more visible.
        width: 24,
        height: 150,
    },
    appearanceSpecs: [
        {
            spec: "slider",
            key: "width",
            label: "Width",
            i18nLabel: "ui.props.appearance.width",
            min: 8,
            max: 30,
        },
        {
            spec: "slider",
            key: "height",
            label: "Height",
            i18nLabel: "ui.props.appearance.height",
            min: 75,
            max: 200,
        },
    ],
    actions: [
        {
            type: "add",
            label: () => t_add("bung"),
            icon: "plus",
            action: (a, p, r) => {
                // Minus height/2 because there is no specified pivot.
                let position = P(0, -a.height / 2).rotate(r).add(Pp(p));
                let apparatus = createApparatus("bung", position);
                let bung = Object.assign(Object.assign({}, apparatus.appearance), requestDiameter(a.width));
                apparatus.appearance = bung;
                apparatus.rotation = r;
                return apparatus;
            }
        }
    ]
};
TestTube = __decorate([
    staticImplements()
], TestTube);
export { TestTube };
export class TestTubeWithSideArm {
    render(appearance) {
        let width = appearance.width;
        let height = appearance.height;
        let offset = 30;
        let holeRadius = appearance.holeDiameter / 2;
        let sideArmLength = 15;
        let tube = new Path();
        tube.addSegments(Segments([[0, 0]], [[0, height - width / 2], undefined, [0, width / 1.55]]));
        mirrorX(tube, width / 2);
        tube.insertSegments(3, Segments([[width, offset + holeRadius]], [[width + sideArmLength, offset + holeRadius]], [[width + sideArmLength, offset - holeRadius]], [[width, offset - holeRadius]]));
        addEdgeLips(tube, { lipSize: 2.0 });
        let liquidMask = tube.clone();
        let graphics = breakPath(tube, 6);
        setDefaultStyle(graphics);
        var hitShape = Shape.Rectangle(new Rectangle(0, 0, width + sideArmLength, height));
        return {
            graphic: graphics,
            hitShape: hitShape,
            liquidMask: liquidMask,
            snapping: [
                { type: "connectable", at: P(width + sideArmLength, offset), facing: 90, },
                { type: "neck", top: P(width / 2, 0), diameter: width, facing: 0 }
            ]
        };
    }
}
TestTubeWithSideArm.properties = {
    label: "Test tube with side arm",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: Object.assign(Object.assign({}, TestTube.properties.defaultAppearance), { holeDiameter: 10 }),
    appearanceSpecs: [
        ...TestTube.properties.appearanceSpecs,
        {
            spec: "slider", key: "holeDiameter", label: "Hole diameter",
            min: 8, max: 20,
        }
    ],
};
function ApparatusClass(ApparatusClass) {
    throw new Error("Function not implemented.");
}
